<template>
  <div class="tc box">
    <div class="c-img"></div>
    <div class="c-text">{{text?text:'暂无数据～'}}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
}
</script>

<style lang="less" scoped>
.box{
  margin-top: 324px;
}
.c-img {
  width: 324px;
  height: 274px;
  background-image: url('~@/assets/images/404.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
}
.c-text {
  font-size: 24px;
  font-weight: 500;
  color: #aaaaaa;
  line-height: 24px;
  text-align: center;
  padding-top: 90px;
}
</style>
